import { Component, OnDestroy, OnInit } from '@angular/core';
import { Tab } from '../../model/tab';
import { TabsService } from '../../services/tabs.service';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';

@Component({
  selector: 'tabs-component',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  tabs: Tab[];

  constructor(private tabsService: TabsService) {
    super();

    this.addSubscription(tabsService.tabClosed, (event) => {
      const activeTab = this.tabsService.getActiveTab();
      if (event.closedTab && event.closedTab === activeTab) {
        if (this.tabs.length > 0) {
          this.openTab(this.tabs[this.tabs.length - 1]);
        }
      }
    });
    this.tabs = [];
  }

  ngOnInit(): void {
    this.tabs = this.tabsService.getTabs();
  }

  ngOnDestroy() {
    this.tabs.forEach((tab) => tab.component.destroy());
    //Obliterate what makes us weak!
  }

  openTab(tab: Tab) {
    this.tabsService.openTab(tab);
  }

  closeTab(tab: Tab) {
    this.tabsService.closeTab(tab);
  }
}
